<template>
    <div style="background:#FAFAFA;" class="pt-5 mt-5">
        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div v-responsive.lg.xl>
      <div>
        <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
        <section>
          <div class="paralax-cover-image has-background-dim">
            <p class="paralax-cover-image-text">
              <div class="content_home" style="z-index: 1!important">
                <h1 style="font-size: 70px" class="font-weight-bold"><span>{{ $t('home_page.Home_titre') }}</span></h1>  
                  <div class="container_animation">
                      <h1 class="rotating-text"><span class="nowrap">
                          <span class="window">
                            <div class="window-inner">
                              <span>{{ $t('home_page.Home_titre_2[0]') }}<br /></span>
                              <span>{{ $t('home_page.Home_titre_2[1]') }}<br /></span>
                              <span>{{ $t('home_page.Home_titre_2[2]') }}<br /></span>
                              <span>{{ $t('home_page.Home_titre_2[3]') }}<br /></span>
                            </div>
                          </span>
                        </span>
                      </h1>
                    </div>
                    

                <p>{{ $t('home_page.Descriptif_message[0]') }}<br> {{ $t('home_page.Descriptif_message[1]') }}</p>
                <div class="row">
                  <div class="trigger ml-3 mt-4">
                    <span>
                                                <img class="mr-3" loading="lazy" src="../../assets/img/writing.png" width="25px"  alt="writing quotes">

                      <!-- <i style="font-size: 20px" class="mr-3 fa fa-file-text" aria-hidden="true"></i>  -->
                      {{ $t('home_page.bouton_devis[0]') }} <i style="font-size: 20px"
                                                                   class="ml-4 fas fa-chevron-down"></i></span>
                    <ul class="devis elevation-24">
                      <li class="font-weight-bold" style="cursor:pointer">{{ $t('home_page.particulier_label') }}</li>
                      <li><a href="/devis/auto"><i><img class="mr-2" width="35"
                                                        src="../../assets/img/icones/menu/cars_quote.png"
                                                        :alt="$t('home_page.bouton_devis[1]')"/></i>
                        {{ $t('home_page.bouton_devis[1]') }}</a></li>
                      <li><a href="/devis/habitation"><i><img class="mr-2" width="35"
                                                              src="../../assets/img/icones/menu/house_quote.png"
                                                              :alt="$t('home_page.bouton_devis[2]')"/></i>
                        {{ $t('home_page.bouton_devis[2]') }}</a></li>
                      <li><a href="/devis/voyage"><i><img class="mr-2" width="35"
                                                          src="../../assets/img/icones/menu/travel_quote.png"
                                                          :alt="$t('home_page.bouton_devis[3]')"/></i>{{
                          $t('home_page.bouton_devis[3]')
                        }}</a></li>
                      <li><a href="/devis/sante"><i><img class="mr-2" width="35"
                                                         src="../../assets/img/icones/menu/health_quote.png"
                                                         :alt="$t('home_page.bouton_devis[4]')"/></i>{{
                          $t('home_page.bouton_devis[4]')
                        }}</a></li>
                      <li><a href="/devis/vie"><i><img class="mr-2" width="35"
                                                       src="../../assets/img/icones/menu/life_quote.png"
                                                       :alt="$t('home_page.bouton_devis[5]')"/></i>{{
                          $t('home_page.bouton_devis[5]')
                        }}</a></li>
                      <li><a href="/plus"><i><img class="mr-2" width="35" src="../../assets/img/icones/menu/add_quote.png"
                                                  :alt="$t('home_page.bouton_devis[6]')"/></i>{{
                          $t('home_page.bouton_devis[6]')
                        }}</a></li>
                      <li class="font-weight-bold" style="cursor:pointer">{{ $t('home_page.entreprise_label') }}</li>
                      <li><a href="/devis/mrp"><i><img class="mr-2" width="30"
                                                       src="../../assets/img/icones/menu/mrp_quote.png"
                                                       alt="devis_mrp"/></i> MRP</a></li>
                      <li><a href="/devis/trc"><i><img class="mr-2" width="35"
                                                       src="../../assets/img/icones/menu/trc_quote.png"
                                                       alt="devis_trc"/></i>TRC</a></li>
                    </ul>
                  </div>

                  <div class="trigger-simulation ml-5 mt-4">
                    <span>
                                                <img class="mr-3" loading="lazy" src="../../assets/img/rocket.png" width="25px"  alt="writing quotes">

                      <!-- <i style="font-size: 20px" class="mr-3 fa fa-file-text" aria-hidden="true"></i>  -->
                      {{ $t('home_page.bouton_simulation_view') }} <i style="font-size: 20px"
                                                                   class="ml-4 fas fa-chevron-down"></i></span>
                    <ul class="devis elevation-24">
                      <li><a href="/simulate/devis/auto"><i><img class="mr-2" width="35"
                                                        src="../../assets/img/icones/menu/cars_quote.png"
                                                        :alt="$t('home_page.bouton_devis[1]')"/></i>
                        {{ $t('home_page.bouton_devis[1]') }}</a></li>
                      <li><a href="/simulate/devis/voyage"><i><img class="mr-2" width="35"
                                                          src="../../assets/img/icones/menu/travel_quote.png"
                                                          :alt="$t('home_page.bouton_devis[3]')"/></i>{{
                          $t('home_page.bouton_devis[3]')
                        }}</a></li>
                    </ul>
                  </div>




                 


                 

                      
                </div>
              </div>
            </p>
          </div>
        </section>
      </div>
    </div>

    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div style="margin-top:50px" v-responsive.sm.xs>
      <div>
        <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
        <section>
          <div class="paralax-cover-image_mobile has-background-dim_mobile">
            <p class="paralax-cover-image-text_mobile">
              <div class="content_home" style="z-index: 1!important;margin-top: 15%;">
                <h1 style="font-size: 50px" class="font-weight-bold"><span>{{ $t('home_page.Home_titre') }}</span></h1>

                  <div class="container_animation-mobile">
                      <h1 class="rotating-text-mobile"><span class="nowrap-mobile">
                          <span class="window-mobile">
                            <div class="window-inner-mobile">
                              <span>{{ $t('home_page.Home_titre_2[0]') }}<br /></span>
                              <span>{{ $t('home_page.Home_titre_2[1]') }}<br /></span>
                              <span>{{ $t('home_page.Home_titre_2[2]') }}<br /></span>
                              <span>{{ $t('home_page.Home_titre_2[3]') }}<br /></span>
                              
                            </div>
                          </span>
                        </span>
                      </h1>
                    </div>

                <p>{{ $t('home_page.Descriptif_message_mobile[0]') }}<br>{{
                    $t('home_page.Descriptif_message_mobile[1]')
                  }}
                  <br> {{ $t('home_page.Descriptif_message_mobile[2]') }}</p>
                <div class="row">
                  <div class="trigger ml-3">
                    <span>
                          <img class="mr-3" loading="lazy" src="../../assets/img/writing.png" width="25px"  alt="writing quotes">

                                              {{ $t('home_page.bouton_devis[0]') }}<i style="font-size: 18px"
                                                                  class="ml-3 fas fa-chevron-down"></i></span>
                    <ul class="devis elevation-24" style="z-index:2">
                      <li class="font-weight-bold" style="cursor:pointer">{{ $t('home_page.particulier_label') }}</li>
                      <li><a href="/devis/auto"><i><img class="mr-2" width="35"
                                                        src="../../assets/img/icones/menu/cars_quote.png"
                                                        :alt="$t('home_page.bouton_devis[1]')"/></i>
                        {{ $t('home_page.bouton_devis[1]') }}</a></li>
                      <li><a href="/devis/habitation"><i><img class="mr-2" width="35"
                                                              src="../../assets/img/icones/menu/house_quote.png"
                                                              :alt="$t('home_page.bouton_devis[2]')"/></i>
                        {{ $t('home_page.bouton_devis[2]') }}</a></li>
                      <li><a href="/devis/voyage"><i><img class="mr-2" width="35"
                                                          src="../../assets/img/icones/menu/travel_quote.png"
                                                          :alt="$t('home_page.bouton_devis[3]')"/></i>{{
                          $t('home_page.bouton_devis[3]')
                        }}</a></li>
                      <li><a href="/devis/sante"><i><img class="mr-2" width="35"
                                                         src="../../assets/img/icones/menu/health_quote.png"
                                                         :alt="$t('home_page.bouton_devis[4]')"/></i>{{
                          $t('home_page.bouton_devis[4]')
                        }}</a></li>
                      <li><a href="/devis/vie"><i><img class="mr-2" width="35"
                                                       src="../../assets/img/icones/menu/life_quote.png"
                                                       :alt="$t('home_page.bouton_devis[5]')"/></i>{{
                          $t('home_page.bouton_devis[5]')
                        }}</a></li>
                      <li><a href="/plus"><i><img class="mr-2" width="35" src="../../assets/img/icones/menu/add_quote.png"
                                                  :alt="$t('home_page.bouton_devis[6]')"/></i>{{
                          $t('home_page.bouton_devis[6]')
                        }}</a></li>
                      <li class="font-weight-bold" style="cursor:pointer">{{ $t('home_page.entreprise_label') }}</li>
                      <li><a href="/devis/mrp"><i><img class="mr-2" width="30"
                                                       src="../../assets/img/icones/menu/mrp_quote.png"
                                                       alt="devis_mrp"/></i> MRP</a></li>
                      <li><a href="/devis/trc"><i><img class="mr-2" width="35"
                                                       src="../../assets/img/icones/menu/trc_quote.png"
                                                       alt="devis_trc"/></i>TRC</a></li>
                    </ul>
                  </div>

                  <div class="trigger-simulation ml-3 mt-3">
                    <span>
                          <img class="mr-3" loading="lazy" src="../../assets/img/rocket.png" width="25px"  alt="writing quotes">

                                              {{ $t('home_page.bouton_simulation_view') }}<i style="font-size: 18px"
                                                                  class="ml-3 fas fa-chevron-down"></i></span>
                    <ul class="devis elevation-24" style="z-index:2">
                      <li><a href="/simulate/devis/auto"><i><img class="mr-2" width="35"
                                                        src="../../assets/img/icones/menu/cars_quote.png"
                                                        :alt="$t('home_page.bouton_devis[1]')"/></i>
                        {{ $t('home_page.bouton_devis[1]') }}</a></li>
                      <li><a href="/simulate/devis/voyage"><i><img class="mr-2" width="35"
                                                              src="../../assets/img/icones/menu/house_quote.png"
                                                              :alt="$t('home_page.bouton_devis[2]')"/></i>
                        {{ $t('home_page.bouton_devis[2]') }}</a></li>
                    </ul>
                  </div>

                </div>
               


              </div>
            </p>
          </div>
        </section>
      </div>
    </div>

        <login-form :visible="showLoginForm" :code_parrain="code_parrain"  @close="showLoginForm = false"></login-form>
    </div>
  </template>
  
  <script>
  
  import Api from '../../services/Api'
  //import LoginForm from '../register.component.vue'
  import LoginForm from '../auth/register.component.vue'
  
  
  export default {
    name: 'AutoRenew',
    components: { LoginForm },
    data() {
        return {
            code_parrain: '',
            showLoginForm: false,
            ToastTabSucess: {
                theme: 'toasted-primary',
                position: 'top-center',
                duration: 5000,
                fitToScreen: true,
                type: 'success',
                className: 'custom-success-class'
            }, // Customized options for success toast
            ToastTabError: {
                theme: 'toasted-primary',
                position: 'top-center',
                duration: 5000,
                fitToScreen: true,
                type: 'error'
            }, // Customized options for error toast
        }
    },
  
    methods: {
        
  
        isMobile: function () {
            if (screen.width <= 760) {
                return true
            } else {
                return false
            }
        },
  
        isTablette() {
            if (screen.width > 425 && screen.width <= 768) {
                return true
            } else {
                return false
            }
        },
  
        isDesktop: function () {
            if (screen.width > 768) {
                return true
            } else {
                return false
            }
        },
  
        
        check_code_parrain(code) {
            Api().post('parrainages/checkbycode', {
                code_parrain: code
            }).then((resultat) => {
                if (resultat.data.code == 0 ) {
                    this.code_parrain = resultat.data.code_parrain  
                    this.showLoginForm = true              
                } else {
                    this.$toasted.show("Le lien n'est pas bon !", this.ToastTabError)
                    setTimeout(() => (
                        this.$router.push('/')
                    ), 5000)
                }
            }).catch((err) => {
                console.log(err)
                // 
                this.$toasted.show("Erreur serveur !", this.ToastTabError)
  
            });
        },
  
  
    },
  
    mounted() {
      window.scrollTo(0, 0);
        // console.log('==> ', this.$route.params.id)
  
        if (this.$route.params.id) {
            this.check_code_parrain(this.$route.params.id)
        }else{
            this.$router.push("/");
        }
  
  
    }
  }
  </script>
  
  <style lang="less" scoped>

@import "../../assets/less/config";
@import "../../assets/css/button.css";
@import "../../assets/css/plateforme-home-section.css";

@keyframes header-animation {
  from {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.play_video_icon_button_container {
  //border: 2px solid #ffa409;
  border-radius: 50%;
  margin-left: -10px;
}
.play_video_icon_button_container_margin {
  margin: 5px;
}
.play_video_icon_button_container_icon {
  font-size: 40px;
  color:#ffa409
}

.play_video_icon_button_container_icon:hover {
  color: #fff;
}

.play_video_icon_button_container:hover {
  border: 2px solid #fff;
  border-radius: 50%;
}

.underline_bar {
  height: 4px;
  width: 150px;
  background: #ffa409;
}

.titre_for_desktop {
  color: #2b2b2b;
  font-size: 25px;
  font-weight: bold;
  text-align: center;
}

.newsletter_titre_desktop {
  color: #2b2b2b;
  font-size: 25px;
  font-weight: bold;
  margin-top: 6%;
  text-align: center;
}

.margin {
  margin-left: 9.5%;
  margin-right: 9.5%;
}

.margin_mobile {
  margin-left: 5%;
  margin-right: 5%;
}

.margin-titre {
  margin-top: 48px;
  padding-bottom: 48px;
}

a, button {
  outline: none;
  cursor: pointer;
}

img {
  max-width: 100%;
}

body > .main {
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-flex-shrink: 0;
  -moz-flex-shrink: 0;
  -ms-flex-shrink: 0;
  flex-shrink: 0;
}

body > .main:after {
  content: '\00a0';
  display: block;
  height: 0;
  visibility: hidden;
}

body > .main > header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  padding: 10px;
  z-index: 0;
}

body > .main > header.fixed {
  position: fixed;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  animation: header-animation 0.35s ease-in-out;
}

body > .main > header.fixed .button-menu i, body > .main > header.fixed .button-menu i:before, body > .main > header.fixed .button-menu i:after {
  background: #505066;
}

body > .main section {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: row;
  -moz-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

@media (min-width: 960px) {
  body > .main section {
    -webkit-flex-wrap: nowrap;
    -moz-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
}

@media (min-width: 1200px) {
  body > .main section {
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    display: inline-block;
    width: 33.33%;
  }

  body > .main section + section {
    margin-left: 40px;
    margin-bottom: 0;
  }
}

body > .main section > div {
  padding: 10px;
  width: 100%;
}

body > .main section > div:first-child {
  width: 100%;
}

@media (min-width: 960px) {
  body > .main section > div:first-child {
    -webkit-box-flex: 1;
    -moz-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: auto;
  }
}

body > .main section > div:last-child {
  min-width: 0;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-flex-basis: 1px;
  -moz-flex-basis: 1px;
  -ms-flex-basis: 1px;
  flex-basis: 1px;
  width: 1px;
}

@media (min-width: 1200px) {
  body > .main section > div:last-child {
    width: 100%;
  }
}

.hero {
  position: relative;
  background-size: cover;
  background-position: center center;
  height: 680px;
  min-height: 320px;
  max-height: 100%;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -ms-flex-pack: center;
  padding: 20px;
}

.hero .content_home {
  position: relative;
  min-height: 280px;
  width: 100%;
  margin-left: 8.5%;
  z-index: 2;
  //background: red;
}

.hero .content_home p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
  width: 100%;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.hero:before {
  content: "";
  position: absolute;
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.22) 30%, rgba(0, 0, 0, 0) 50%);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  //z-index: 10;
}

.hero:after {
  content: "";
  position: absolute;
  background: radial-gradient(ellipse at center, rgba(94, 88, 121, 0.25) 20%, rgba(37, 34, 47, 0.28) 110%);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.hero.bg-1 {
  background-image: url('../../assets/img/home/new_home/new_design.png');
  height: 580px;
}

h1 {
  font-weight: 100;
  font-size: 58px;
}

h2 {
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
}

h3 {
  font-size: 20px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 40px;
}

h1, h2 {
  margin: 0 0 20px;
  color: #fff;
}

p {
  font-size: 14px;
}

.button-primary {
  padding: 14px 38px;
  border-radius: 10px;
  //cursor: pointer;
  margin: 0 auto;
  font-size: 85%;
  font-weight: bold;
  text-transform: uppercase;
  border: 0 none;
  color: #000000;
  transition: all 0.3s;
  background: linear-gradient(to bottom left, rgb(255, 164, 9) 0%, rgb(255, 164, 9) 80%);
}

.button-primary:hover, .button-primary:focus {
  transform: translate3d(0, -3px, 0);
  box-shadow: 0 8px 12px 5px rgba(255, 164, 9, 0.35);
  color: #fff;
}

.button-secondary {
  padding: 14px 38px;
  border-radius: 10px;
  border: 2px solid #ffa409;
  margin: 0 auto;
  font-size: 85%;
  height: 50px;
  font-weight: bold;
  text-transform: uppercase;
  transition: all 0.3s;
}

.button-secondary:hover, .button-secondary:focus {
  border: none;
  background: #ffa409;
  transform: translate3d(0, -3px, 0);
  color: #000000;
}

.card {
  position: relative;
  margin: 2%;
  width: 140px;
  min-width: 140px;
  height: 140px;
  background: #fff;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.99);
  border-top: 1px solid rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(15px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
}

.card:hover {
  cursor: pointer;
  background: #ffa409;
  box-shadow: 0 15px 15px rgba(0, 0, 0, 0.4);
}

.img-bx {
  position: absolute;
  top: -10px !important;
  left: -20px !important;
  width: 130%;
  height: 100%;
  border-radius: 10px;
  overflow: hidden;
  transform: translateY(30px) scale(0.5);
  transform-origin: top;
}

.img-bx img {
  position: absolute;
  top: -15px;
  //left: 10%;
  width: 100%;
  object-fit: cover;
}

.content {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 10px;
}

.content .detail {
  justify-content: center;
  align-items: center;
  text-align: center;
}

.content .detail h2 {
  color: #444;
  font-size: 12px;
  font-weight: bold;
  margin-left: -75px;
}


.card_mobile {
  position: relative;
  margin: 1.5%;
  width: 120px;
  min-width: 100px;
  height: 120px;
  background: #fff;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.99);
  border-top: 1px solid rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(15px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
}

.card_mobile:hover {
  cursor: pointer;
  background: #ffa409;
  box-shadow: 0 15px 15px rgba(0, 0, 0, 0.4);
}

//LOGO ASSUREUR GRISER
.slideassureur {
  img {
    filter: grayscale(2);
  }
}

.slideassureur img:hover {
  filter: grayscale(0);
}

.slide-img img {
  height: 60px;
}

.marquee {
  padding-top: 10px;
  padding-bottom: 10px
}

input[type="email"] {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  font-size: 16px;
  height: auto;
  margin: 0;
  outline: 0;
  padding: 15px;
  width: 300px;
  background-color: rgba(115, 115, 115, 0.58);
  color: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03) inset;
  margin-bottom: 30px;
}

input[type="email"]::placeholder {
  color: #fff;
  font-size: 20px;
}

.watch_video span {
  width: 227px;
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 15px;
  position: relative;
  text-transform: none;
  color: #fff;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border: 1.5px solid #5B94BC;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  // justify-content: center;
  align-items: center;
  // justify-content: center;
  background-color: #5B94BC;
}



.watch_video_mobile span {
  width: 227px;
  font-weight: bold;
  letter-spacing: 0px;
  font-size: 15px;
  background: none;
  position: relative;
  text-transform: none;
  background-color: #5B94BC;
  color: #fff;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border: 2px solid #5B94BC;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.newsletter span {
  width: 200px;
  font-weight: bold;
  letter-spacing: 0px;
  font-size: 16px;
  position: relative;
  text-transform: none;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border: 2px solid #000000;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.newsletter:hover span {
  //min-width: 220px;
  border-radius: 10px;
  border: none;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #000000;
  background: #ffa409;
}

.watch_video:hover span {
  border-radius: 10px;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #000000;
  background: #ffa409;
  border: 1.5px solid #ffa409;
}

.trigger {
  width: 210px;
}

.trigger span {
  width: 227px;
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 15px;
  position: relative;
  background: #ffa409;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.trigger ul.devis {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  overflow: hidden;
  transform: scaley(0);
  transform-origin: top;
  transition: 150ms transform 150ms;
}

.trigger ul.devis a {
  opacity: 0;
  transition: 150ms opacity 0ms;
}

.trigger ul.devis li {
  top: 0;
  left: 0;
  width: 227px;
  height: 44px;
  padding: 0 20px;
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  border-left: 0px solid #eee;
  transition: 150ms border-left 0ms;
}

.trigger ul.devis li:before {
  content: '';
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, #eee, #fcfcfc);
  position: absolute;
  top: 0;
  left: 0;
}

.trigger ul.devis li:last-of-type {
  border-radius: 0 0 22px 22px;
}

.trigger ul.devis li a {
  text-decoration: none;
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
}

.trigger ul.devis li:hover {
  border-left: 10px solid #eee;
}

.trigger:hover span {
  border-radius: 22px 22px 0 0;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #fff;
}

.trigger:hover ul.devis {
  transform: scaley(1);
}

.trigger:hover ul.devis a {
  opacity: 1;
}





.trigger-simulation {
  width: 240px;
}

.trigger-simulation span {
  width: 240px;
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 15px;
  position: relative;
  background: #5B94BC;
  color: #000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.trigger-simulation ul.devis {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  overflow: hidden;
  transform: scaley(0);
  transform-origin: top;
  transition: 150ms transform 150ms;
}

.trigger-simulation ul.devis a {
  opacity: 0;
  transition: 150ms opacity 0ms;
}

.trigger-simulation ul.devis li {
  top: 0;
  left: 0;
  width: 240px;
  height: 44px;
  padding: 0 20px;
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  border-left: 0px solid #eee;
  transition: 150ms border-left 0ms;
}

.trigger-simulation ul.devis li:before {
  content: '';
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, #eee, #fcfcfc);
  position: absolute;
  top: 0;
  left: 0;
}

.trigger-simulation ul.devis li:last-of-type {
  border-radius: 0 0 22px 22px;
}

.trigger-simulation ul.devis li a {
  text-decoration: none;
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
}

.trigger-simulation ul.devis li:hover {
  border-left: 10px solid #eee;
}

.trigger-simulation:hover span {
  border-radius: 22px 22px 0 0;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #fff;
}

.trigger-simulation:hover ul.devis {
  transform: scaley(1);
}

.trigger-simulation:hover ul.devis a {
  opacity: 1;
}

/*---------- testimonial css start ----------*/
.pn_testimonial_box {
  font-weight: 300;
  padding: 2rem;
  margin: 20px;
  border: 1px solid #ffa409;
  position: relative;
  transition: 1s;
  transform: scale(0.9);
  background-color: #fff;
  -webkit-border-radius: 4rem;
  -moz-border-radius: 4rem;
  -ms-border-radius: 4rem;
  border-radius: 4rem;
}

.pn_testimonial_box p {
  width: 220px;
  height: 130px;
}


.pn_testimonial_box:hover {
  box-shadow: 4px 6px 10px #d6d8da;
  border: 1px solid #fff;
  transform: scale(1);
  position: relative;
  z-index: 1;
}


.pn_testimonial_box_mobile {
  font-weight: 300;
  padding: 2rem;
  margin: 20px;
  border: 1px solid #ffa409;
  position: relative;
  transition: 1s;
  height: 250px;
  transform: scale(0.9);
  background-color: #fff;
  -webkit-border-radius: 4rem;
  -moz-border-radius: 4rem;
  -ms-border-radius: 4rem;
  border-radius: 4rem;
}

.pn_testimonial_box_mobile p {
  width: 280px;
  height: 110px;
}


.pn_testimonial_box_mobile:hover {
  box-shadow: 4px 6px 10px #d6d8da;
  border: 1px solid #fff;
  transform: scale(1);
  position: relative;
  z-index: 1;
}

.pn_review_rating img {
  width: 20%;
}

.pn_review_profile img {
  position: absolute;
  margin: -1rem -5rem 0;
}

.pn_review_profile span {
  position: absolute;
  margin-left: 2%;
  //margin-top: 8%;
  font-weight: bold;
  color: #000000;
  font-size: 18px;
}

.pn_review_profile_mobile span {
  position: absolute;
  margin-left: 2%;
  margin-top: 4%;
  font-weight: bold;
  color: #000000;
  font-size: 18px;
}

.pn_review_profile img {
  width: 50%;
}

.pn_review_profile_mobile img {
  width: 20%;
}


@media (max-width: 575px) {
  /*---------- testimonial css start ----------*/
  .pn_reviews {
    padding: 3rem 0;
  }

  .pn_reviews h1 {
    font-size: 2rem;
    padding-bottom: 1rem !important;
  }

  .pn_testimonial_box {
    padding: 2rem;
    margin: 1rem;
    border: 1px solid #ffa409;
    position: relative;
    -webkit-border-radius: 4rem;
    -moz-border-radius: 4rem;
    -ms-border-radius: 4rem;
    border-radius: 4rem;
    min-width: 93%;
  }

  .pn_review_profile img {
    position: absolute;
    margin: -1.1rem -3rem 0;
  }

  .pn_review_profile span {
    position: absolute;
    padding: 1rem;
  }

  .pn_review_rating img {
    width: auto;
  }
}


.paralax-cover-image {
  background-image: url('../../assets/img/home/new_home/new_design.png');
  position: relative;
  background-size: cover;
  background-position: 50%;
  min-height: 650px;
  width: 100%;
  margin: 0 0 0;
  display: flex;
  padding: 20px;
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;

}

.paralax-cover-image p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
}

.paralax-cover-image .paralax-cover-image-text,
.paralax-cover-image h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image.has-background-dim:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.paralax-cover-image {
  background-attachment: fixed;
  background-position: 50% 0;
}


.paralax-cover-image_mobile {
  background-image: url('../../assets/img/home/new_home/new_design.png');
  position: relative;
  background-size: cover;
  background-position: 50%;
  min-height: 550px;
  width: 100%;
  margin: 0 0 0;
  padding-bottom: 40px;
  display: flex;
  //padding: 20px;
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;

}

.paralax-cover-image_mobile p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
  padding-bottom: 20Px;
}

.paralax-cover-image_mobile .paralax-cover-image-text_mobile,
.paralax-cover-image_mobile h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image_mobile.has-background-dim_mobile:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.paralax-cover-image_mobile {
  background-attachment: fixed;
  background-position: 50% 0;
}

.container-mascote {
  max-width: 100%;
}

.android-app h2 {
  color: #0d4e78;
  font-weight: 100;
  font-size: 40px;
}

.text-lg-left {
  text-align: left !important;
}

.android-app ul li {
  font-size: 20px;
  font-weight: 400;
  padding-bottom: 8px;
}

.list_macotte_test {
  font-size: 20px;
  font-weight: 400;
  padding-bottom: 8px;
}

.img-fluid {
  max-width: 100%;
  height: auto;
}


.half-half-image-text {
  padding: 70px 0px;
}

.half-half-image-text h1 {
  color: #800000;
}

.half-half-image-text .content {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 35px 0px;
}

.half-half-image-text .content p {
  font-size: 22px;
}

.half-half-image-text .img {
  min-height: 320px;
  height: 100%;
  border-radius: 10px;
}


.slider-logo {
  display: flex;
  height: auto;
  margin: auto;
  overflow: hidden;
  align-items: center;
}

.slider-logo:before {
  position: absolute;
  z-index: 1;
  left: 0;
  content: "";
  width: 23.95%;
  height: 110px;
  background: linear-gradient(-90deg, hsla(0, 0%, 96.9%, 0), #f7f7f7);
}

.slider-logo:after {
  position: absolute;
  right: 0;
  content: "";
  width: 23.95%;
  height: 110px;
  background: linear-gradient(90deg, hsla(0, 0%, 96.9%, 0), hsla(0, 0%, 96.9%, 0.99) 99%);
}

.slider-logo .slick-track {
  display: flex;
  animation: scroll 35s linear infinite;
  -webkit-animation: scroll 35s linear infinite;
  width: calc(240px * 10);
}

.slider-logo .slid {
  display: flex;
}

.slider-logo .slid img {
  width: 115px;
  height: 70px;
  padding: 10px;
  background-color: white;
  //cursor: pointer;
  margin: 20px;
  border-radius: 8px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
}

.slider-logo .slid_mobile {
  display: flex;
}

.slider-logo .slid_mobile img {
  width: 100px;
  height: 70px;
  padding: 10px;
  background-color: white;
  //cursor: pointer;
  margin: 20px;
  border-radius: 8px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
}


.col-text {
  height: 20em;
}

.grid-flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  flex-direction: row;
  -webkit-flex-direction: row;
  -webkit-flex-wrap: wrap;
  -webkit-justify-content: space-around;
}

.col {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.col-left {
  -webkit-box-ordinal-group: -1;
  -webkit-order: -1;
  -ms-flex-order: -1;
  order: -1;
}

.col-text {
  display: flex;
  align-items: center;
  justify-content: center;
}

.Aligner-item {
  width: 70%;
  font-size: 20px
}

.col-image {
  margin-left: 7%;
  margin-top: -15% !important;
  background-size: contain;
  background-position: center center;
  //box-shadow: 9px 12px 18px rgb(0 0 0 / 5%)
  -webkit-filter: drop-shadow(5px -6px 5px #b2b1b1);
  filter: drop-shadow(5px -6px 5px #8f8e8e);
  background-image: url('../../assets/img/home/new_home/Mascot_assuraf.png');
}

@media (max-width: 640px) {
  .grid-flex {
    height: 40em;
    display: -webkit-flex;
    -webkit-flex-direction: column;
    flex-direction: column;
  }

  .col {
    order: vertical;
  }

  .col-left {
    -webkit-box-ordinal-group: 0;
    -webkit-order: 0;
    -ms-flex-order: 0;
    order: 0;
  }

  .col-text div p {
    padding: 1em;
  }

  .Aligner-item {
    width: 90%;
  }

}


.radio-inputs {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  border-radius: 0.5rem;
  background-color: #EEE;
  box-sizing: border-box;
  box-shadow: 0 0 0px 1px rgba(0, 0, 0, 0.06);
  padding: 0.7rem;
  width: 82% !important;
  font-size: 14px;
}

.radio-inputs .radio {
  flex: 1 1 auto;
  text-align: center;
}

.radio-inputs .radio input {
  display: none;
}

.radio-inputs .radio .name {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  border: none;
  padding: 1rem 0;
  color: rgba(51, 65, 85, 1);
  transition: all .15s ease-in-out;
  font-size: 18px !important;
}

.radio-inputs .radio input:checked + .name {
  background-color: #fff;
  font-weight: 600;
  height: 40px !important;
  font-size: 18px !important;
}


.radio-inputs-mobile {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  border-radius: 0.5rem;
  background-color: #EEE;
  box-sizing: border-box;
  box-shadow: 0 0 0px 1px rgba(0, 0, 0, 0.06);
  padding: 0.7rem;
  width: 100% !important;
  font-size: 14px;
}

.radio-inputs-mobile .radio {
  flex: 1 1 auto;
  text-align: center;
}

.radio-inputs-mobile .radio input {
  display: none;
}

.radio-inputs-mobile .radio .name {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  border: none;
  padding: 1rem 0;
  color: rgba(51, 65, 85, 1);
  transition: all .15s ease-in-out;
  font-size: 18px !important;
}

.radio-inputs-mobile .radio input:checked + .name {
  background-color: #fff;
  font-weight: 600;
  height: 40px !important;
  font-size: 18px !important;
}


.container_plateforme {
width: 100%;
height: auto;
display: flex;
flex-direction: column;
align-items: center;
margin: 25px 0px;
}

.servcies-section-wrapper {
//width: 60%;
display: flex;
justify-content: center;
flex-wrap: wrap;
gap: 45px;
}

.services-box {
box-shadow: rgba(0, 0, 0, 0.2) 0px 18px 50px -10px;
//background-color: #a9a7a7;
color: white;
width: 45%;
padding: 5px 5px;
border-radius: 12px;
display: flex;
justify-content: center;
flex-direction: column;
//align-items: center;
//gap: 10px;
transition: all 0.3s ease-in-out;
}

.services-box:hover {
i {
  margin-left: 10px;
}
transition: all 0.4s ease-out;
background-color: #ffa409;
//font-weight:400;
a {
  color: #fff!important;
}
}

.services-box h3 {
//font-size: 15px;
margin-top: -10px;
margin-bottom: 0;
margin-left: 10px;
text-align: start;
color: #2b2b2b;
text-transform: none;
}

.services-box p {
margin: 10px;
text-align: start;
color: #2b2b2b;
font-size: 15px!important;
}

.services-box i {
background-color: white;
color: #ffa409;
width: 60px;
height: 60px;
display: flex;
justify-content: center;
align-items: center;
border-radius: 40px;
margin-bottom: 16px;
margin-top: 16px;
font-size: 24px;
}







.container_plateforme {
width: 100%;
height: auto;
display: flex;
flex-direction: column;
align-items: center;
margin: 25px 0px;
}

.servcies-section-wrapper {
//width: 60%;
display: flex;
justify-content: center;
flex-wrap: wrap;
gap: 45px;
}

.services-box {
box-shadow: rgba(0, 0, 0, 0.2) 0px 18px 50px -10px;
//background-color: #a9a7a7;
color: white;
width: 45%;
padding: 5px 5px;
border-radius: 12px;
display: flex;
justify-content: center;
flex-direction: column;
//align-items: center;
//gap: 10px;
transition: all 0.3s ease-in-out;
}

.services-box:hover {
i {
  margin-left: 10px;
}
transition: all 0.4s ease-out;
background-color: #ffa409;
//font-weight:400;
}

.services-box h3 {
//font-size: 15px;
margin-top: -10px;
margin-bottom: 0;
margin-left: 10px;
text-align: start;
color: #2b2b2b;
text-transform: none;
}

.services-box p {
margin: 10px;
text-align: start;
color: #2b2b2b;
font-size: 15px!important;
}

.services-box i {
background-color: white;
color: #ffa409;
width: 60px;
height: 60px;
display: flex;
justify-content: center;
align-items: center;
border-radius: 40px;
margin-bottom: 16px;
margin-top: 16px;
font-size: 24px;
}




/*== start of code for tooltips ==*/
.tool {
  cursor: help;
  position: relative;
}


/*== common styles for both parts of tool tip ==*/
.tool::before,
.tool::after {
  left: 50%;
  opacity: 0;
  position: absolute;
  z-index: -100;
}

.tool:hover::before,
.tool:focus::before,
.tool:hover::after,
.tool:focus::after {
  opacity: 1;
  transform: scale(1) translateY(0);
  z-index: 100;
}


/*== pointer tip ==*/
.tool::before {
  border-style: solid;
  border-width: 1em 0.75em 0 0.75em;
  border-color: #565C61 transparent transparent transparent;
  bottom: 105%;
  content: "";
  margin-left: -0.5em;
  transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26), opacity .65s .5s;
  transform: scale(.6) translateY(-90%);
}

.tool:hover::before,
.tool:focus::before {
  transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26) .2s;
}



/*== speech bubble ==*/
.tool::after {
  background: #565C61;
  border-radius: .25em;
  bottom: 120%;
  color: #EDEFF0;
  font-size: 15px;
  content: attr(data-tip);
  margin-left: -8.75em;
  padding: 1em;
  transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26) .2s;
  transform: scale(.6) translateY(50%);
  width: 17.5em;

}

.tool:hover::after,
.tool:focus::after {
  transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26);
}

@media (max-width: 760px) {
  .tool::after {
    font-size: .75em;
    margin-left: -5em;
    width: 10em;
  }
}




















/* From Uiverse.io by vinodjangid07 */ 
.button {
width: 45px;
height: 45px;
border-radius: 50%;
background-color: #ffa409;
border: none;
font-weight: 600;
display: flex;
align-items: center;
justify-content: center;
box-shadow: 0px 0px 0px 1.5px #ffa409;
cursor: pointer;
transition-duration: 0.3s;
overflow: hidden;
position: relative;
}

.svgIcon {
width: 20px;
transition-duration: 0.3s;
}

.svgIcon path {
fill: #000000;
}

.button:hover {
width: 190px;
border-radius: 10px;
transition-duration: 0.3s;
background-color: #ffa409;
align-items: center;
}

.button:hover .svgIcon {
/* width: 20px; */
transition-duration: 0.3s;
transform: translateY(-200%);
}

.button::before {
position: absolute;
bottom: -30px;
//{{ $t('home_page.bouton_simulation_view') }}
content: attr(data-content);
font-weight: 500;
color: #fff;
/* transition-duration: .3s; */
font-size: 0px;
text-transform: none;
}

.button:hover::before {
font-size: 13px;
opacity: 1;
bottom: unset;
/* transform: translateY(-30px); */
transition-duration: 0.3s;
}







.rotating-text {
font-size: 70px!important;
line-height: 1.2;
font-weight: bold;
}

.window {
display: inline-block;
overflow: hidden;
flex-grow: 1; /* Allows .window to grow and take up remaining space */
height: 80px!important;
vertical-align: bottom;
}

.window-inner {
display: inline-block;
animation: scroll-text 15s ease-in-out infinite;
color: #ffa409;
}
.window span {
display: block;
}

@keyframes scroll-text {
0% {
  transform: translateY(0%); /* trust */
}
26.66% {
  transform: translateY(calc(-26.66%)); /* Simplement */
}
50.33% {
  transform: translateY(calc(-50.33%)); /* Autrement */
}
75% {
  transform: translateY(calc(-75%)); /* Sereinement */
}
100% {
  transform: translateY(calc(-74.33%)); /* Pour vous (at the end) */
}
}

.container_animation {
width: 100%;
max-width: 50rem;
margin-top: -35px
}

.nowrap {
white-space: nowrap;
}

html {
background: #292929;
color: #edebeb;
padding: 1rem;
}

.rotating-text-mobile {
font-size: 50px!important;
line-height: 1.2;
font-weight: bold;
}

.window-mobile {
display: inline-block;
overflow: hidden;
flex-grow: 1; /* Allows .window to grow and take up remaining space */
height: 50px!important;
vertical-align: bottom;
}

.window-inner-mobile {
display: inline-block;
animation: scroll-text 15s ease-in-out infinite;
color: #ffa409;
}
.window-mobile span {
display: block;
}

@keyframes scroll-text {
0% {
  transform: translateY(0%); /* trust */
}
26.66% {
  transform: translateY(calc(-26.66%)); /* Simplement */
}
50.33% {
  transform: translateY(calc(-50.33%)); /* Autrement */
}
75% {
  transform: translateY(calc(-75%)); /* Sereinement */
}
100% {
  transform: translateY(calc(-74.33%)); /* Pour vous (at the end) */
}
}

.container_animation-mobile {
width: 100%;
max-width: 50rem;
margin-top: -35px
}

.nowrap-mobile {
white-space: nowrap;
}

html-mobile {
background: #292929;
color: #edebeb;
padding: 1rem;
}

  .form {
    background-color: #fff;
    padding: 1.5rem;
  }
  
  .form .page {
    height: auto;
  }

  </style>